import React, { useEffect } from 'react';
import { LayoutGrid, Grid3X3, List } from 'lucide-react';

export default function ViewSwitcher({ activeView, onViewChange }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.metaKey || e.ctrlKey) {
        if (e.key === '1') {
          e.preventDefault();
          onViewChange('grid');
        } else if (e.key === '2') {
          e.preventDefault();
          onViewChange('compact');
        } else if (e.key === '3') {
          e.preventDefault();
          onViewChange('list');
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onViewChange]);

  const views = [
    { id: 'grid', label: 'Lưới lớn (⌘1)', icon: LayoutGrid },
    { id: 'compact', label: 'Lưới nhỏ siêu dày (⌘2)', icon: Grid3X3 },
    { id: 'list', label: 'Danh sách (⌘3)', icon: List }
  ];

  return (
    <div className="flex items-center bg-[#30060A] p-0.5 rounded-lg border border-[#5E1019] select-none">
      {views.map((item) => {
        const Icon = item.icon;
        const isActive = activeView === item.id;
        return (
          <button
            key={item.id}
            onClick={() => onViewChange(item.id)}
            title={item.label}
            className={`px-2 py-1 rounded-md text-xs flex items-center justify-center gap-1 transition-all duration-150 ${
              isActive
                ? 'bg-gradient-to-r from-[#F5A623] to-[#E58F10] text-[#240306] shadow-xs font-bold'
                : 'text-amber-200/60 hover:text-[#FFF5E6] hover:bg-[#4D0A11]'
            }`}
          >
            <Icon size={14} />
          </button>
        );
      })}
    </div>
  );
}
